export default "__VITE_ASSET__43b52e6c__"